<template>
  <CFooter>
    <div>
      <span class="ml-1"
        >D-DOTS Admin &copy; {{ new Date() | moment("YYYY") }}</span
      >
    </div>
  </CFooter>
</template>

<script>
export default {
  name: "TheFooter"
};
</script>
